export default __webpack_public_path__ + "static/200nng_ilija_bojchovikj-454b3baa3d6b99c831da3ebd8cb4cf52.png";